import React from 'react';
import ReactTooltip from 'react-tooltip';
import Icon from '@mdi/react';
import { mdiInformation } from '@mdi/js';
import ReactHtmlParser from 'react-html-parser';
import { Content, Container } from './style';

const Tooltip = ({ text, size, dataId, icon }) => {
  const tooltipId = dataId || `tooltip_${Math.random().toString(36).substr(2, 9)}`;

  return (
    <>
      <Container data-tip="" data-for={tooltipId}>
        {icon ? icon : <Icon size={size ? size : 1} path={mdiInformation} />}
      </Container>
      <ReactTooltip
        id={tooltipId}
        type={'dark'}
        place={'top'}
        effect={'solid'}
        delayHide={300}
        clickable={true}
        className="custom-tooltip"
      >
        <Content>{ReactHtmlParser(text)}</Content>
      </ReactTooltip>
    </>
  );
};

export default Tooltip;